/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * gringotts/v1/services/secret_service.proto
 * OpenAPI spec version: version not set
 */

/**
 * Lifecycle state of a Secret.

 - SECRET_STATE_ACTIVE: Usable — a current version is available.
 - SECRET_STATE_PENDING_AUTHORIZATION: OAuth consent not yet completed (no version written).
 - SECRET_STATE_DEGRADED: Backing store compromised (see `state_reason` for the precise cause).
 */
export type V1SecretState = (typeof V1SecretState)[keyof typeof V1SecretState];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const V1SecretState = {
  SECRET_STATE_UNSPECIFIED: 'SECRET_STATE_UNSPECIFIED',
  SECRET_STATE_ACTIVE: 'SECRET_STATE_ACTIVE',
  SECRET_STATE_PENDING_AUTHORIZATION: 'SECRET_STATE_PENDING_AUTHORIZATION',
  SECRET_STATE_DEGRADED: 'SECRET_STATE_DEGRADED',
} as const;
